/**
 * @file Support Form
 */

/**
 * Support Form component
 */
const vSupportForm = () => {
	const supportForm = document.querySelector( '.v-support-form' );

	if ( ! supportForm ) {
		return;
	}

	const selects    = supportForm.querySelectorAll( 'select' );
	const checkboxes = document.querySelectorAll( '[type="checkbox"]' );
	const addBtns    = document.querySelectorAll( '.v-support-form__dynamic-btn--add' );
	const removeBtns = document.querySelectorAll( '.v-support-form__dynamic-btn--remove' );

	/**
	 * Handles the  remove button click;
	 *
	 * @param {Event} e The event object
	 */
	const removeBtnHandler = ( e ) => {
		e.preventDefault();
		const addArea    = e.target.closest( '.v-support-form__dynamic-wrap' );
		const fieldset   = addArea.parentNode;
		const thisItem   = e.target.closest( '.v-support-form__dynamic' );
		const removeEvt  = new CustomEvent( 'vdynamicremove', {
			detail: {
				setId: fieldset.id,
			},
		} );
		const addBtn     = fieldset.querySelector( '.v-support-form__dynamic-btn--add' );
		let currentIndex = Number( addArea.dataset.currentIndex );

		addArea.removeChild( thisItem );
		currentIndex--;

		addArea.setAttribute( 'data-current-index', currentIndex );

		if ( addBtn.hasAttribute( 'disabled' ) ) {
			addBtn.removeAttribute( 'disabled' );
			addBtn.classList.remove( 'v-support-form__dynamic-btn--disabled' );
		}

		document.dispatchEvent( removeEvt );
	};

	[ ...selects ].forEach( ( select ) => {
		const selectParent = select.parentNode;

		if ( selectParent.classList.contains( 'v-support-form__select' ) ) {
			return;
		}

		const wrapper = document.createElement( 'span' );
		wrapper.classList.add( 'v-support-form__select' );
		selectParent.insertBefore( wrapper, select );
		wrapper.appendChild( select );

		const arrow = document.createElement( 'span' );
		arrow.classList.add( 'v-support-form__select-arrow' );
		wrapper.appendChild( arrow );
	} );

	[ ...checkboxes ].forEach( ( checkbox ) => {
		const checkboxParent = checkbox.parentNode;
		if ( checkboxParent.classList.contains( 'v-support-form__checkbox-label' ) ) {
			return;
		}

		const box = document.createElement( 'span' );
		box.classList.add( 'v-support-form__checkbox' );
		checkboxParent.insertBefore( box, checkbox.nextSibling );
		checkbox.classList.add( 'v-support-form__checkbox-original' );
		checkboxParent.classList.add( 'v-support-form__checkbox-label' );
	} );

	[ ...addBtns ].forEach( ( btn ) => {
		btn.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			const parentFieldset = btn.parentNode.parentNode;
			const addArea	       = parentFieldset.querySelector( '.v-support-form__dynamic-wrap' );
			const maxFields	     = Number( addArea.dataset.max );
			const currentIndex   = Number( addArea.dataset.currentIndex ) + 1;

			if ( currentIndex > maxFields ) {
				return;
			}

			const template  = parentFieldset.querySelector( '.v-support-form__dynamic--template' );
			const clone     = template.cloneNode( true );
			const removeBtn = clone.querySelector( '.v-support-form__dynamic-btn--remove' );
			const formElems = clone.querySelectorAll( '[name]' );
			const itemLabel = clone.querySelector( '.v-support-form__label' );

			[ ...formElems ].forEach( ( elem ) => {
				let curName = elem.getAttribute( 'name' );
				curName     = curName + '_' + currentIndex;
				elem.setAttribute( 'name', curName );
			} );

			removeBtn.addEventListener( 'click', removeBtnHandler );

			itemLabel.innerHTML = itemLabel.textContent + ' ' + currentIndex;

			clone.classList.remove( 'v-support-form__dynamic--template' );
			addArea.appendChild( clone );
			addArea.setAttribute( 'data-current-index', currentIndex );

			if ( currentIndex === maxFields ) {
				btn.setAttribute( 'disabled', '' );
				btn.classList.add( 'v-support-form__dynamic-btn--disabled' );
			}
		} );
	} );

	document.addEventListener( 'vdynamicremove', ( e ) => {
		const set = document.querySelector( '#' + e.detail.setId );

		if ( ! set ) {
			return;
		}

		const currentIndex = Number( set.dataset.currentIndex );
		if ( currentIndex === 0 ) {
			return;
		}

		const items      = [ ...set.querySelectorAll( '.v-support-form__dynamic' ) ].filter( ( e ) => ! e.classList.contains( 'v-support-form__dynamic--template' ) );
		[ ...items ].forEach( ( item, idx ) => {
			const formElems = item.querySelectorAll( '[name]' );
			const itemLabel = item.querySelector( '.v-support-form__label' );

			[ ...formElems ].forEach( ( elem ) => {
				let curName = elem.getAttribute( 'name' );
				const base  = curName.substring( 0, curName.lastIndexOf( '_' ) );
				curName     = base + '_' + ( idx + 1 );
				elem.setAttribute( 'name', curName );
			} );

			const labelBase     = itemLabel.textContent.substring( 0, itemLabel.textContent.length - 2 );
			itemLabel.innerHTML = labelBase + ' ' + ( idx + 1 );
		} );
	} );

	/* [ ...dynamicSets ].forEach( ( set ) => {
		set.addEventListener( 'vdynamicremove', ( e ) => {

		} );
	} ); */

	if ( removeBtns ) {
		removeBtns.forEach( ( btn ) => {
			btn.addEventListener( 'click', removeBtnHandler );
		} );
	}
};

export default vSupportForm;
